import { ChangeDetectorRef, Component } from "@angular/core";
import { CalendarUIService } from "app/js/src/domain/calendar-ui-service";
import {
  KeepOriginalOrder,
  SplitStringByCapitalLetter,
} from "../../../domain/common/ui-utils";
import { Observable, Subscription } from "rxjs";

@Component({
  selector: "evrideo-calendar-grid-columns-customization",
  templateUrl: "./calendar-grid-columns-customization.component.html",
  styleUrls: ["./calendar-grid-columns-customization.component.scss"],
})
export class CalendarGridColumnsCustomizationComponent {
  private columnsSubscription: Subscription;
  public active = false;
  public KeepOriginalOrder = KeepOriginalOrder;
  public SplitStringByCapitalLetter = SplitStringByCapitalLetter;
  public columns = {};

  constructor(
    private calendarUIService: CalendarUIService,
    private changeDetectorRef: ChangeDetectorRef,
  ) {}

  ngOnInit() {
    this.columnsSubscription = this.calendarUIService.ViewColumns.subscribe(
      (cols) => {
        setTimeout(() => {
          this.columns = { ...cols };
          this.changeDetectorRef.detectChanges();
        }, 0);
      },
    );
  }
  ngOnDestory() {
    if (this.columnsSubscription) {
      this.columnsSubscription.unsubscribe();
    }
  }

  show(): void {
    this.active = true;
    this.changeDetectorRef.detectChanges();
  }

  hide(): void {
    this.active = false;
    this.changeDetectorRef.detectChanges();
  }

  toggle(): void {
    this.active = !this.active;
    this.changeDetectorRef.detectChanges();
  }

  itemClicked(input) {
    this.columns[input] = !this.columns[input];
    this.calendarUIService.setViewColumns(Object.assign({}, this.columns));
    this.changeDetectorRef.detectChanges();
  }
  reset(): void {
    this.calendarUIService.resetToDefaults();
  }
}
